import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=5cf760d2&"
import script from "./UserInformation.vue?vue&type=script&lang=ts&"
export * from "./UserInformation.vue?vue&type=script&lang=ts&"
import style0 from "./UserInformation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports